<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div class="columns">
          <div class="column"></div>
          <div class="column is-half has-text-centered">
            <h1 class="title is-spaced">Esqueceu sua senha?</h1>
            <h2 class="subtitle">
              Sem problemas!
              <br />
              Digite abaixo seu e-mail cadastrado que lhe enviaremos um link
              para redefini-la.
            </h2>

            <form @submit.prevent="forgotPassword" class="has-text-centered">
              <b-field>
                <b-input
                  size="is-medium"
                  v-model="email"
                  class="is-expanded"
                  type="email"
                  placeholder="E-mail"
                ></b-input>
              </b-field>

              <button
                class="button is-primary is-medium is-fullwidth has-text-weight-bold"
              >
                Enviar link
              </button>

              <br />
              <div class="has-text-left">
                <router-link to="/" class="button">
                  <b-icon icon="arrow-alt-circle-left"></b-icon>
                  <span>&nbsp;</span>Voltar
                </router-link>
              </div>
            </form>
          </div>
          <div class="column"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common.js";

export default {
  mixins: [common],

  data() {
    return {
      email: "",
      isLoading: false
    };
  },

  methods: {
    forgotPassword() {
      this.isLoading = true;
      this.$store
        .dispatch("forgotPassword", {
          email: this.email
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Link enviado no e-mail!",
              message:
                "Clique no link que enviamos para o seu e-mail e redefina sua senha. Lembre-se de verificar o spam!",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$router.push("/"),
              onCancel: () => this.$router.push("/")
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
</style>
